/**
 * @generated SignedSource<<9a469f47971fbe6eec19ddcba3a8f19b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivityVisibility = "AUTHENTICATED" | "MEMBERS" | "UNAUTHENTICATED";
export type LocationKind = "HYBRID" | "IN_PERSON" | "ONLINE";
export type RewardKind = "BADGE" | "LEARNING" | "MONEY" | "SWAG";
import { TimeZone } from "@/common/relayCustomScalar";
export type UpdateEventInput = {
  about?: string | null | undefined;
  audience?: UpdateAudienceGroupsInput | null | undefined;
  banner?: any | null | undefined;
  description?: string | null | undefined;
  gettingStarted?: string | null | undefined;
  inviteEmail?: string | null | undefined;
  purpose?: string | null | undefined;
  rewards?: ReadonlyArray<RewardInput> | null | undefined;
  rules?: string | null | undefined;
  shortDescription?: string | null | undefined;
  slug?: string | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
  thumbnail?: any | null | undefined;
  timeline?: UpdateTimelineInput | null | undefined;
  title?: string | null | undefined;
  useLegacyDescription?: boolean | null | undefined;
  visibility?: ActivityVisibility | null | undefined;
};
export type RewardInput = {
  amount?: AmountRangeInput | null | undefined;
  description: string;
  kind: RewardKind;
};
export type AmountRangeInput = {
  end: number;
  start: number;
};
export type UpdateTimelineInput = {
  endDate?: any | null | undefined;
  location?: LocationInput | null | undefined;
  startDate?: any | null | undefined;
  steps?: ReadonlyArray<TimelineStepInput> | null | undefined;
  timezone?: TimeZone | null | undefined;
};
export type TimelineStepInput = {
  date: any;
  label: string;
};
export type LocationInput = {
  city?: string | null | undefined;
  country?: string | null | undefined;
  kind: LocationKind;
};
export type UpdateAudienceGroupsInput = {
  groups: ReadonlyArray<AudienceGroupInput>;
};
export type AudienceGroupInput = {
  items: ReadonlyArray<string>;
  label: string;
  position: number;
};
export type EventOverviewPageUpdateEventMutation$variables = {
  id: string;
  input: UpdateEventInput;
};
export type EventOverviewPageUpdateEventMutation$data = {
  readonly updateEvent: {
    readonly node: {
      readonly description: string | null | undefined;
      readonly id: string;
    };
  };
};
export type EventOverviewPageUpdateEventMutation = {
  response: EventOverviewPageUpdateEventMutation$data;
  variables: EventOverviewPageUpdateEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "updateEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventOverviewPageUpdateEventMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EventOverviewPageUpdateEventMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c1567e15fe875fd1f365dbabf221e960",
    "id": null,
    "metadata": {},
    "name": "EventOverviewPageUpdateEventMutation",
    "operationKind": "mutation",
    "text": "mutation EventOverviewPageUpdateEventMutation(\n  $id: ID!\n  $input: UpdateEventInput!\n) {\n  updateEvent(id: $id, input: $input) {\n    node {\n      id\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e25e10a4da6ca6093e33623d74e52f1";

export default node;
